import React, { useEffect, useState } from "react";
import axios from "axios";
import "../index.css";

const CustomerList = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const customersPerPage = 5;

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND}/api/customers`)
      .then(response => {
        setCustomers(response.data);
        setLoading(false);
      })
      .catch(error => {
        setError("Failed to fetch customers");
        setLoading(false);
      });
  }, []);

  const handleDelete = (id) => {
    axios.delete(`${process.env.REACT_APP_BACKEND}/api/customers/${id}`)
      .then(() => {
        setCustomers(customers.filter(customer => customer._id !== id));
      })
      .catch(() => {
        alert("Failed to delete customer");
      });
  };

  const filteredCustomers = customers.filter(customer =>
    customer.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    customer.email.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const indexOfLastCustomer = currentPage * customersPerPage;
  const indexOfFirstCustomer = indexOfLastCustomer - customersPerPage;
  const currentCustomers = filteredCustomers.slice(indexOfFirstCustomer, indexOfLastCustomer);

  const totalPages = Math.ceil(filteredCustomers.length / customersPerPage);

  if (loading) return <p>Loading customers...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className="customer-list-container container mt-4">
      <h2 className="customer-list-title text-center mb-4">Customer List</h2>

      <input
        type="text"
        className="customer-search-input form-control mb-3"
        placeholder="Search by name or email..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />

      <div className="table-responsive">
        <table className="customer-table table table-striped table-bordered">
          <thead className="customer-table-head">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Email</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentCustomers.map((customer, index) => (
              <tr key={customer._id}>
                <td>{indexOfFirstCustomer + index + 1}</td>
                <td>{customer.name}</td>
                <td>{customer.email}</td>
                <td>
                  <button className="customer-delete-button btn btn-sm" onClick={() => handleDelete(customer._id)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="customer-pagination d-flex justify-content-between align-items-center">
        <button className="btn btn-primary" disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)}>
          Previous
        </button>
        <span>Page {currentPage} of {totalPages}</span>
        <button className="btn btn-primary" disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)}>
          Next
        </button>
      </div>
    </div>
  );
};

export default CustomerList;
